import { createFileRoute, redirect } from "@tanstack/react-router";
import type { UserActor } from "@corpuscomplete/core/actor";
import { AuthenticatedShell } from "@corpuscomplete/web/modules/common/components/authenticated-shell";
import { getCachedSession } from "../auth/client";
import * as Sentry from "@sentry/react";

/**
 * Authenticated shell route and session boundary.
 * Contract: route entrypoints under this layout receive a verified user actor,
 * while data hydration is handed off to ZeroInit and downstream @corpuscomplete/core-ui providers.
 */
export const Route = createFileRoute("/_authenticated")({
  component: AuthenticatedShell,
  beforeLoad: async ({ location }) => {
    const { data } = await getCachedSession();
    if (!data) {
      Sentry.setUser(null);
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
    if (data.user.status === "pending") {
      throw redirect({ to: "/waitlist" });
    }
    Sentry.setUser({ id: data.user.id });
    const actor: UserActor = { type: "user", userId: data.user.id };
    return { session: data.session, user: data.user, actor };
  },
});
